const buildType = require("./models");

const BankAccount = buildType({
  initializer: (model, document) => {
    model.bank = document?.bank;
    model.type = document?.type;
    model.company = document?.company;
    model.currency = document?.currency;
    model.name = document?.name;
    model.shortName = document?.shortName;
    model.longName = document?.longName;
    model.currentBalance = document?.currentBalance;
    model.externalSystemId = document?.externalSystemId;
  },
  code: "bankAccounts",
  singular: "Bank Account",
  plural: "Bank Accounts",
  afterLoad: (m) => {
    const type = m.bank?.country?.id === "6V597tv2Wt2Ir7FBnasf" /* US */ ? m.type?.englishName : m.type?.spanishName;
    const bank = m.bank?.country?.id === "6V597tv2Wt2Ir7FBnasf" /* US */ ? m.bank?.name + " Bank" : "Banco " + m.bank?.name;
    const shortCurrency = m.bank?.country?.id === "6V597tv2Wt2Ir7FBnasf" /* US */ ? "" : m.currency?.symbol ?? "";
    m.shortName = `${m.bank?.name} - ${m.company?.code} - ${type}${m.name ? " " + m.name : ""}${
      shortCurrency !== "" ? " " + shortCurrency : ""
    }`.trim();
    m.longName = `${bank} - ${m.company?.name} - ${type}${m.name ? " " + m.name : ""}${
      m.currency?.name ? " (" + m.currency?.name + ")" : ""
    }`.trim();
    return m;
  },
});

BankAccount.prototype.getDisplayName = function () {
  const type = this.bank?.country?.id === "6V597tv2Wt2Ir7FBnasf" /* US */ ? this.type?.englishName : this.type?.spanishName;
  return `${this.name ? this.name : type}${this.currency?.symbol ? " (" + this.currency?.symbol + ")" : ""}`.trim();
};

BankAccount.prototype.getCurrentBalance = function () {
  const balance = this.currentBalance ? this.currentBalance : { date: "2020-01-01T00:00:00Z", balance: 0, isAutomatic: false };
  return balance;
};

module.exports = BankAccount;
